import React from "react";

import { Module } from "../../components";
import { AboutUs } from "./Pages/AboutUs";

const SobreNos = () => {
  return (
    <Module moduleName="Caixa Seguradora">
      <Module.Page
        path="/"
        title="Sobre Nós"
        page={AboutUs}
        description="Sobre Nós"
      />
    </Module>
  );
};

SobreNos.propTypes = {};

export default SobreNos;
